import styled from '@emotion/styled';
import BaseButton from '@portalterreno/react-ui-core/Button';

const Button = styled(BaseButton)({
  padding: 13,
  marginBottom: 11,
  marginTop: 18
});

export default Button;
